import { useConnect } from '@hooks/@lore/query-connect';
import { event_networkId } from '@/utils/query-helpers';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          ...event_networkId(network),
          ...params,
          request: { $not: 'Outreach' }
        }
      }
    },
    ...pagination
  }, {
    keepPreviousData: true
  });
}
